import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
export var PromotedTagAlignment;
(function (PromotedTagAlignment) {
    PromotedTagAlignment["Left"] = "Left";
    PromotedTagAlignment["Right"] = "Right";
    PromotedTagAlignment["Center"] = "Center";
})(PromotedTagAlignment || (PromotedTagAlignment = {}));
const b = bemClassBuilder('v-promoted-tag');
export const PromotedTag = observer(({ label, className, alignment }) => {
    return (_jsx("div", Object.assign({ className: b.block({ alignment }, className) }, { children: _jsx("div", Object.assign({ className: b.element('label') }, { children: label })) })));
});
PromotedTag.displayName = 'PromotedTag';
